import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ServicesProvider } from 'src/providers/services';
import { DatePipe } from '@angular/common';
import { ModalController, ToastController } from '@ionic/angular';
import { CancelbookingPage } from '../cancelbooking/cancelbooking.page';
import { PopupalertPage } from '../popupalert/popupalert.page';
import { AddCall } from 'src/providers/addvCall';

@Component({
  selector: 'app-notification',
  templateUrl: './notification.page.html',
  styleUrls: ['./notification.page.scss'],
})
export class NotificationPage implements OnInit {

  notifyDetl = [];
  EmptyData: any;

  showSlides1: any;
  doctorId: any;
  bookingId: any;
  queueList = [];
  profileImage: String;
  bookingAmnt: any;
  queuePos: any;
  QuePos: any;
  status: any;
  scrollEvent: any;
  pageNo: any;

  option = {
    slidesPerView: 2,
    centeredSlides: false,
    spaceBetween: -210,
  }
  bookListReq: any;
  queReq: any;
  cancelReq: any;
  refEvent: any;
  nextCount: any;
  spinner: boolean;


  constructor(
    public router: Router,
    public services: ServicesProvider,
    private datePipe: DatePipe,
    public modalCtrl: ModalController,
    public toastCtrl: ToastController,
    public addCall: AddCall,
  ) { }

  ngOnInit() { }

  ionViewWillEnter() {
    this.status = null;
    this.pageNo = 1;
    this.showSlides1 = null;
    this.spinner = true;
    this.appmtList();
  }

  async presentToast(msg) {
    const toast = await this.toastCtrl.create({
      message: msg,
      duration: 2000,
      cssClass: 'toastStyle',
    });
    toast.present();
  }

  async Alertpopup(msg, status) {
    const alert = await this.modalCtrl.create({
      component: PopupalertPage,
      cssClass: 'class_alert',
      componentProps: {
        'msg': msg,
        'sts': status,
      }
    });
    await alert.present();
  }

  doRefresh(event) {
    this.refEvent = event;
    this.spinner = false;
    this.appmtList();
  }
  refFunc() {
    if (this.refEvent) {
      this.refEvent.target.complete();
    }
  }
  infyFunc() {
    if (this.scrollEvent) {
      this.scrollEvent.target.complete();
    }
  }


  loadData(event) {
    if(this.nextCount!=0) {
      this.scrollEvent = event;
      this.pageNo += 1;
      this.spinner = false;
      this.appmtList();
    } else {
      event.target.disabled = true;
    }
  }

  backToHome() {
    this.router.navigate(['/tabs/home']);
  }



  showSlide1(index, doctor_id, bookingId, clinic_id, bookDate) {
    this.setQueue();
    this.QuePos = "0th";
    this.queuePos = 0;
    //this.profileImage = localStorage.getItem("Patient_Profile");
    this.doctorId = doctor_id;
    this.bookingId = bookingId;
    this.myQueueList(clinic_id, index, bookDate);
  }
  setQueue() {
    this.queueList = [];
    let item = "assets/img/persnIcon1.png";
    for (let i = 1; i <= 5; i++) {
      this.queueList.push(item);
    }
  }
  async presentModal(bookingId, bookingAmnt) {
    this.bookingId = bookingId;
    this.bookingAmnt = bookingAmnt;
    const modal = await this.modalCtrl.create({
      component: CancelbookingPage,
      cssClass: 'ModelConCSSCancelPopUp',
      componentProps: {
        bookingId: bookingId,
        bookingAmnt: bookingAmnt
      },
    });
    modal.onDidDismiss()
      .then((data) => {
        const res = data;
        console.log(res);
        if (res.data != null) {
          console.log(res.data);
          console.log("booking id=>", res.data.bookingId);
          console.log("booking amnt=>", res.data.bookingAmnt);
          this.cancelAppmt();
          this.notifyDetl = [];
          // this.patientBookedAppointmentList();
        }
      });
    return await modal.present();
  }








  appmtList() {
    try {
      if (this.bookListReq) {
        this.bookListReq.unsubscribe();
      }
      let today = new Date().toISOString().split("T")[0];
      let curTime = new Date().toTimeString().split(" ")[0];
      let requestdata = JSON.stringify({
        "patientId": localStorage.getItem("patient_id"),
        "currentDate": today,
        "current_time": curTime,
        "pageno": this.pageNo,
        "limit": 10
      });
      this.bookListReq = this.services.postRequest("patientBookedAppointmentList", requestdata).subscribe(res => {
        console.log("Booked List => ", res);
        this.spinner = false;
        this.status = res.status;
        this.EmptyData = res.status;
        if(res.status == 1) {
          this.nextCount = res.data[0].nextCount;
          if (this.pageNo == 1) {
            this.notifyDetl = [];
          }
          for (let item of res.data[0].details) {
            this.notifyDetl.push(item);
          }
        }
        console.log("Next Count -> ", this.nextCount);
        
        this.refFunc();
        this.infyFunc();
      }, (err) => {
        console.log(err);
        this.refFunc();
        this.infyFunc();
      });
    } catch (err) {
      console.log(err);
      this.refFunc();
      this.infyFunc();
    }
  }

  myQueueList(clinic_id, idx, bDate) {
    if (this.queReq) {
      this.queReq.unsubscribe();
    }
    let getDate = new Date();
    let date = getDate.getFullYear() + "-" + (getDate.getMonth() + 1) + "-" + getDate.getDate();
    let time = new Date().toTimeString().split(" ")[0];
    let requestdata = JSON.stringify({
      "clinic_id": clinic_id,
      "currentDate": date,
      "currentTime": time,
      "doctor_id": this.doctorId,
      "bookingId": this.bookingId
    });
    this.queReq = this.services.postRequest("memberQueueDetailsForParticularBooking", requestdata).subscribe(res => {
      console.log("Queue Details => ", res);
      let curDate = new Date().toISOString().split("T")[0];
      let bkDate = bDate.split(" ")[0];
      if (this.showSlides1 == idx) {
        this.showSlides1 = null;
      } else {
        if (curDate === bkDate) {
          this.showSlides1 = idx;
        } else {
          this.presentToast("Queue will be available on appointment date");
          this.showSlides1 = null;
        }
      }

      if (res.status != 0) {
        this.QuePos = res.data[0].queuePosition;
        let arr = res.data[0].queuePosition.split("");
        let posStr = "";
        for (let i of arr) {
          if (i == "1" || i == "2" || i == "3" || i == "4" || i == "5" || i == "6" || i == "7" || i == "8" || i == "9" || i == "0") {
            posStr = posStr + i;
          }
        }
        this.queuePos = Number(posStr);

        for (let i = 0; i <= 4; i++) {
          if (i == (Number(this.queuePos) - 1)) {
            this.queueList[i] = res.data[0].userData[0].profile_image;
          } else if (i == 4 && (Number(this.queuePos) - 1) > 4) {
            this.queueList[4] = res.data[0].userData[0].profile_image;
          }
        }
      }
    });
  }

  cancelAppmt() {
    if (this.cancelReq) {
      this.cancelReq.unsubscribe();
    }
    console.log("bookingId = ", this.bookingId);
    let curTime = new Date().toString().split(" ")[4];
    let requestdata = JSON.stringify({
      "bookingId": this.bookingId,
      "patientId": localStorage.getItem("patient_id"),
      "cancel_time": curTime
    });
    this.cancelReq = this.services.postRequest("cancelDoctorAppointment", requestdata).subscribe(response => {
      console.log("Doctors List => ", response);
      if (response.status == 1) {
        this.notifyDetl = [];
        // this.Alertpopup("Your Appointment cancelled successfully, Your amount will be refunded within 7 working days", response.status);
        this.Alertpopup(this.addCall.title502, response.status);
        this.spinner = true;
        this.appmtList();
      } else {
        // this.Alertpopup("Your Appointment not cancelled! Please try again later!", response.status);
        this.Alertpopup(this.addCall.title503, response.status);
      }
    }, (err) => {
      alert(err);
    });
  }












  getFormattedDateTime(dateTime, callFor) {
    if (!dateTime) {
      return "";
    }
    var Value;
    switch (callFor) {
      case "Time":
        if (dateTime.indexOf("T") > -1) {
          Value = dateTime.split("T")[1];
        } else if (dateTime.indexOf(" ") > -1) {
          Value = dateTime.split(" ")[1];
        } else {
          Value = dateTime;
        }
        var hourEnd = Value.indexOf(":");
        var H = +String(Value).substr(0, hourEnd);
        var h = H % 12 || 12;
        var ampm = (H < 12 || H === 24) ? "AM" : "PM";
        // var ampm = (H < 12 || H === 24) ? this.addCall.title458 : this.addCall.title459;
        let timeString = h + String(Value).substr(hourEnd, 3) + " " + ampm;
        if (h < 10) {
          timeString = '0' + timeString;
        }
        return timeString;
      case "Date":
        return this.datepipeTransform(new Date(dateTime), "dd MMM yyyy");
      case "DateTime":
        return this.datepipeTransform(new Date(dateTime), "dd MMM yyyy h:mm a");
    }
  }
  datepipeTransform(date: any, format: string): any {
    return this.datePipe.transform(date, format);
  }
}
